<template>
    <div>
        <div v-show="!mb">
            <el-steps class="registerWrapper" :active="active" align-center>
                <el-step title="注册方式" description="">
                </el-step>
                <el-step title="注册信息" description="">
                </el-step>
                <el-step title="注册成功" description="">
                </el-step>
            </el-steps>
            <register-first @nextStep="nextStep" v-show="active===1"></register-first>
            <register-second @nextStep="nextStep" :distinguishNorZh="distinguishNorZh" v-show="active===2"></register-second>
            <register-third   v-show="active===3" :userName="distinguishNorZh"></register-third>
            <div class="text-s-size numberColor registerWrapper m-auto">
                *遇到错误请联系客服：400-0127-985
            </div>
        </div>
        <div v-show="mb">
            <div class="delFloat mb commonBackground rounded-medium">
                <div class="m-auto delFloat">
                    <div class="float-left  text-center rounded-medium"  @click="mb=false">
                        <div><img src="../../../assets/img/register/registerUser.png" height="128" width="128"/></div>
                        <div class="text-l-size font-weight-bold">注册用户</div>
                    </div>
                    <div class="float-left   text-center rounded-medium" @click="mb=false">
                        <div><img src="../../../assets/img/register/groupBuy.png" height="128" width="206"/></div>
                        <div class="text-l-size font-weight-bold">校园团购卡</div>
                    </div>
                    <div class="float-left text-center rounded-medium" @click="mb=false">
                        <div><img src="../../../assets/img/register/teacher.png" height="128" width="128"/></div>
                        <div class="text-l-size font-weight-bold">教师卡</div>
                    </div>
                </div>
                <div class="desc">
                    <div class="font-weight-bold">新手说明：</div>
                    <div class="text-secondary">
                        <div>
                            ①vip卡会员：登录网站——点击“注册新用户”——输入激活码和密码——完善信息——激活成功
                        </div>
                        <div>
                            ②无会员用户：登录网站——点击“注册新用户”——完成注册——点击“在线购卡”——支付成功——激活成功
                        </div>
                         <div>
                            注：激活成功后，再次登录网站时使用注册账号（绑定的手机号）和注册密码进行登录，激活码和激活密码仅使用一次。
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import registerFirst from './components/registerFirst'
    import registerSecond from './components/registerSecond'
    import registerThird from './components/registerThird'
    export default {
        name: "registerDashboard",
        components:{
            registerFirst,
            registerThird,
            registerSecond
        },
        data(){
            return{
                mb:true,

                active:1,
                checked:false,
                //获取第一步是手机号注册或账号注册
                distinguishNorZh:''
            }
        },
        methods:{
            nextStep(val){
                this.distinguishNorZh=val.title;
                console.log(val);
                this.active=val.active;
                // val.active==='2'?this.active=2:val.active==='3'?this.active=3:1
            },
            handleClick(){

            }
        }
    }
</script>
<style lang="scss">
    .numberInput{
        .el-input__inner{
            height:50px;
        }
    }
</style>
<style lang="scss" scoped>
    .mb{
        width:640px;
        margin:100px auto 0 auto;
        padding: 50px 20px;
        .m-auto{
            >div{
                cursor: pointer;
                margin-right: 63px;

            }
            >div:hover{
                background: #d1e6ff;
            }
            >div:nth-last-of-type(1){
                margin-right: 0;

            }
        }
        .desc{
            margin-top: 40px;
            .text-secondary{
                div{
                    line-height: 30px;
                }
            }
        }
    }
    .topNav{
        height: 110px;
        background: #2E86FF;
        width: 100%;
        .sonLevel{
            position: relative;
            margin: 0 auto;
            width: 1300px;
            .sonLevelLeft{
                position: absolute;
                left: 0;
                top: 30px;
                height: 50px;
            }
            .sonLevelRight{
                position: absolute;
                right: 0;
                top:30px;
                height: 50px;
            }
        }
    }
    .registerWrapper{

        width:500px;
        margin: 80px auto;

        .registerWrapperSon{
            position: absolute;
            margin: 80px 0 60px;
        }
    }
</style>